export const SITE = {
  name: 'Hawrat Design Studio',
  url: 'https://hawrat.com',
  email: 'orders@hawrat.com',
  whatsappNumber: '255741791606',
  phoneDisplay: '+255 741 791 606',
  phoneTel: '+255741791606',
  instagram: 'https://www.instagram.com/hawratdesignstudio/',
  workerUrl: 'https://order-worker.ebrahimgulamali.workers.dev/',
  // Set to true ONLY after enabling Cloudflare Image Resizing on the zone.
  // When false, srcset is omitted and the original image is served.
  cloudflareImagesEnabled: false,
  whatsappUrl: (message) =>
    `https://wa.me/255741791606${
      message ? `?text=${encodeURIComponent(message)}` : ''
    }`,
};

/**
 * Generate a Cloudflare-resized URL for an image. Falls back to the original
 * src when CF image resizing is not enabled.
 * https://developers.cloudflare.com/images/transform-images/
 */
export function cfImage(src, { width, quality = 85 } = {}) {
  if (!SITE.cloudflareImagesEnabled || !src || !width) return src;
  // Strip leading slash; CF accepts both relative and absolute paths
  const path = src.replace(/^https?:\/\/[^/]+/, '').replace(/^\//, '');
  return `/cdn-cgi/image/width=${width},format=auto,quality=${quality}/${path}`;
}

/**
 * Generate a srcset string at the given widths. Returns undefined when
 * CF image resizing is disabled (so the <img> falls back to its src).
 */
export function cfSrcSet(src, widths = [320, 480, 640, 960, 1280]) {
  if (!SITE.cloudflareImagesEnabled || !src) return undefined;
  return widths.map((w) => `${cfImage(src, { width: w })} ${w}w`).join(', ');
}
